<template>
  <section class="guided-mode__card guided-mode-question-group">
    <guided-mode-visual
      :media="media"
      :fallback-icon="mdiImageOutline"
      :size="mediaSize"
      interactive
      @toggle-size="$emit('toggle-size')"
    />
    <p class="guided-mode__prompt">{{ prompt }}</p>
    <p v-if="instructions" class="guided-mode__instructions">{{ instructions }}</p>
    <option-input
      :options="options"
      :value="selectedValues"
      multiple
      @select="$emit('option-selected', $event)"
    />
  </section>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue'
import { mdiImageOutline } from '@mdi/js'
import { OptionInput } from '@/components/assessment-inputs'
import type { AssessmentInputOption } from '@/components/assessment-inputs'
import GuidedModeVisual from './GuidedModeVisual.vue'
import type { GuidedModeMedia } from '../types/guided-mode.types'

export default defineComponent({
  name: 'GuidedModeQuestionGroup',
  components: { GuidedModeVisual, OptionInput },
  props: {
    prompt: { type: String, required: true },
    instructions: { type: String, default: '' },
    options: { type: Array as PropType<AssessmentInputOption[]>, default: () => [] },
    selectedValues: { type: Array as PropType<string[]>, default: () => [] },
    media: { type: Object as PropType<GuidedModeMedia | null>, default: null },
    mediaSize: { type: String, default: 'default' },
  },
  emits: ['option-selected', 'toggle-size'],
  data: () => ({ mdiImageOutline }),
})
</script>
